var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component.is_show_label)?_c('p',{staticClass:"caption mb-0",class:{ required: _vm.isRequired }},[_vm._v(" "+_vm._s(_vm.component.component_label)+" "+_vm._s(_vm.checkForFileTypes() ? `(${_vm.checkForFileTypes()})` : null)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }